import type { ExternalAgent } from "../modules/employees/types";
import { apiGet } from "./utils";

export const externalAgentsApi = {
  getAll: async (): Promise<ExternalAgent[]> => {
    return apiGet<ExternalAgent[]>("/api/v1/external_agents");
  },
};
